// extracted by mini-css-extract-plugin
export default {"header":"TableScrollArea_header__-o-FA","scrolled":"TableScrollArea_scrolled__JU4Do"};